import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

export const devConfig = {
  apiKey: "AIzaSyD8ig5pJm87a3sdl-cH9gg621j22QMoc1c",
  authDomain: "retroboard-7a224.firebaseapp.com",
  databaseURL: "https://retroboard-7a224-default-rtdb.firebaseio.com",
  projectId: "retroboard-7a224",
  storageBucket: "retroboard-7a224.appspot.com",
  messagingSenderId: "585852554440",
  appId: "1:585852554440:web:737594c57449380840a9fd"
};

// Points to Retroboard.net
export const prodConfig = {
  apiKey: "AIzaSyDaBXYly0o2WF9v_MT3uiSkObyyAZ8aBJ0",
  authDomain: "dart-board.firebaseapp.com",
  databaseURL: "https://dart-board.firebaseio.com",
  projectId: "dart-board",
  storageBucket: "dart-board.appspot.com",
  messagingSenderId: "17146428490",
  appId: "1:17146428490:web:0bb9a80cfb023c673e7ab3"
}

// Initialize Firebase — auto-detect prod vs dev by hostname
const isProduction = window.location.hostname === 'retroboard.net';
export const fbApp = initializeApp(isProduction ? prodConfig : devConfig);

export const fbAuth = getAuth(fbApp);
export const fbDatabase = getDatabase(fbApp);
export const fbFunctions = getFunctions(fbApp);

const ANALYTICS_CONSENT_KEY = "retroboard-analytics-consent";

// Bump when adding/removing a tracking purpose (new vendor, new pixel, new
// analytics SDK). Bumping invalidates every existing consent and forces a
// re-prompt. Do NOT bump for unrelated changes (bug fixes, UI tweaks, copy
// edits) — that annoys users without compliance value.
//
// Version history:
//   1 — Firebase Analytics only
const CURRENT_CONSENT_VERSION = 1;

// 12 months — ICO/GDPR guidance. After this the banner re-prompts even
// without a version bump.
const CONSENT_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;

type ConsentValue = "accepted" | "rejected";

interface StoredConsent {
  value: ConsentValue;
  consentedAt: string; // ISO 8601
  version: number;
}

export function getAnalyticsConsent(): ConsentValue | null {
  const raw = localStorage.getItem(ANALYTICS_CONSENT_KEY);
  if (!raw) return null;

  let parsed: StoredConsent;
  try {
    parsed = JSON.parse(raw);
  } catch {
    // Corrupt, or the pre-v1 bare-string format. Re-prompt; the next decision
    // overwrites with the new shape.
    return null;
  }

  if (parsed.version !== CURRENT_CONSENT_VERSION) return null;
  if (Date.now() - new Date(parsed.consentedAt).getTime() > CONSENT_MAX_AGE_MS) return null;

  return parsed.value;
}

export function setAnalyticsConsent(value: ConsentValue): void {
  const record: StoredConsent = {
    value,
    consentedAt: new Date().toISOString(),
    version: CURRENT_CONSENT_VERSION,
  };
  localStorage.setItem(ANALYTICS_CONSENT_KEY, JSON.stringify(record));
  if (value === "accepted") {
    initAnalyticsIfSupported();
  }
}

async function initAnalyticsIfSupported(): Promise<void> {
  const { getAnalytics, isSupported } = await import("firebase/analytics");
  if (await isSupported()) getAnalytics(fbApp);
}

// Only initialize analytics if user has previously accepted
if (getAnalyticsConsent() === "accepted") {
  initAnalyticsIfSupported();
}
